module.exports = __webpack_public_path__ + "img/product_1.b265b1a.jpg";